import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_serial_numbers_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { owner?: string, project?: string, material?: string, vendor_lot?: string, lot?: string, license_plate?: string, lookup?: string, is_archived?: boolean, warehouse?: string, top?: number, skip?: number }): Promise<{ serial_numbers?: $frontendTypes.FootprintApiManager.public_serial_number[] }> 
  {
    let $url = `${environment.backendUrl}api/serial_numbers/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

